module.exports = __webpack_public_path__ + "img/block2_img1.35372e3a.png";